import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth/auth'
import user from './modules/user/user'
import applicant from './modules/applicant/applicant'
import recognition from './modules/applicant/applicant'
import institution from './modules/institution/institution'


import _get from 'lodash/get'
import _set from 'lodash/set'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  getters: {
    getItem: (state) => (path, default_value) => {
      return _get(state, path, default_value)
    }
  },
  mutations: {
    setItem(state, {path, value}) {
      _set(state, path, value)
    }
  },
  actions: {
    actionSetItem({commit}, payload) {
      commit('setItem', payload)
    },
  },
  modules: {
    auth, user, applicant, recognition, institution
  }
})
